import { Component, Input, OnInit } from '@angular/core';
import { CaisServiceService } from '../../cais-service.service';
import { NgClass, CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatListItem } from '@angular/material/list';
import { TableModule } from 'primeng/table';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-address-details',
    templateUrl: './address-details.component.html',
    imports: [CommonModule, NgClass, MatDividerModule, MatListItem,
        ReactiveFormsModule, FormsModule, Select, TableModule],
    providers: [],
    styleUrls: ['./address-details.component.scss']
})
export class AddressDetailsComponent implements OnInit {

  @Input('addressColumns') addressColumns: any;  
  constructor(public caisServiceService: CaisServiceService) { }
  ngOnInit() {
  }

}
